import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Ivory — warm cream background, forest green accents, editorial serif name.
// Luxurious and warm. Suited for design, marketing, creative, and senior roles.
// ATS-safe: single column, all content is plain selectable text.
export const ivoryStyles = {
  meta: { label: "Ivory (warm editorial)" },

  page: {
    paddingTop: 52,
    paddingBottom: 52,
    paddingLeft: 60,
    paddingRight: 60,
    backgroundColor: "#F8F5EE",     // warm cream
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: "#2C2A24",
    lineHeight: 1.52,
  },

  // ── Header — large serif name, green role tag, muted contact ────────────
  header: { marginBottom: 18 },
  headerName: {
    fontSize: TYPE.name + 6,
    fontFamily: FONTS.serif,        // editorial serif for the name
    color: "#2C2A24",
    letterSpacing: 0.2,
    marginBottom: 5,
    lineHeight: 1.2,
  },
  headerHeadline: {
    fontSize: TYPE.body,
    color: "#3D6B4F",               // forest green
    fontFamily: FONTS.sansBold,
    letterSpacing: 2,
    textTransform: "uppercase",
    marginTop: 2,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: "#8A8880",
    marginTop: 8,
    flexDirection: "row",
    flexWrap: "wrap",
  },
  sep: { color: "#C8C4BC" },
  headerRule: {
    borderBottomWidth: 1,
    borderBottomColor: "#2C2A24",
    marginTop: 14,
  },

  // ── Sections ─────────────────────────────────────────────────────────────
  section: { marginTop: 20 },
  sectionHeadingWrap: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionHeading: {
    fontSize: TYPE.body,
    fontFamily: FONTS.serif,        // serif section headings
    color: "#3D6B4F",
    letterSpacing: 0.5,
    fontStyle: "italic",
  },
  sectionRule: {
    flex: 1,
    borderBottomWidth: 0.5,
    borderBottomColor: "#C8C4BC",
    marginLeft: 10,
  },

  itemGroup: { marginBottom: 14 },
  itemGroupTight: { marginBottom: 7 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.sansBold,
    color: "#2C2A24",
  },
  itemTitleAlt: { fontFamily: FONTS.sans, color: "#6A6864" },
  itemTitleMuted: { fontFamily: FONTS.sans, color: "#8A8880" },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansItalic,
    color: "#6A6864",
    marginTop: 2,
  },
  itemDate: {
    fontSize: TYPE.meta,
    color: "#8A8880",
    fontFamily: FONTS.sans,
  },

  body: { fontSize: TYPE.body, color: "#2C2A24", marginTop: 3, lineHeight: 1.6 },
  meta: { fontSize: TYPE.meta, color: "#6A6864", marginTop: 2 },
  chipsLine: { fontSize: TYPE.meta, marginTop: 4, color: "#8A8880" },
  labelStrong: { fontFamily: FONTS.sansBold, color: "#3D6B4F" },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 6 },
  bulletRow: { flexDirection: "row", marginBottom: 3 },
  bulletMark: { width: 12, fontSize: TYPE.body, color: "#3D6B4F" },
  bulletText: { flex: 1, fontSize: TYPE.body, color: "#2C2A24", lineHeight: 1.6 },

  link: { color: "#3D6B4F", textDecoration: "underline" },
  linkSmall: {
    color: "#3D6B4F",
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};